import { colors, Tag } from "@biblioteksentralen/react";
import { GuessState, PublicationTag } from "../types";

type Props = { guessState: GuessState; tag: PublicationTag; onClick: (tag: PublicationTag) => void };

export const TitleOrAuthorTag = ({ guessState, tag, onClick }: Props) => {
  // We want to disable click both on correct and incorrect guesses, the latter because
  // otherwise we can end up in an invalid state when clicking rapidly
  const hasBeenGuessed = !!guessState && ["correct", "incorrect"].includes(guessState);

  const background =
    guessState === "correct"
      ? colors.accentGreen
      : guessState === "incorrect"
      ? colors.statusRedLight
      : guessState === "current"
      ? colors.lightGreen
      : colors.white;

  const color =
    guessState === "correct" ? colors.white : guessState === "incorrect" ? colors.statusRed : colors.accentGreen;

  return (
    <Tag.Root
      marginInlineStart="0!important"
      padding={{ base: "0.25rem 0.5rem", md: "0.5rem" }}
      fontWeight={600}
      onClick={hasBeenGuessed ? undefined : () => onClick(tag)}
      as={hasBeenGuessed ? "div" : "button"}
      background={background}
      color={color}
      border={hasBeenGuessed ? `2px solid ${colors.accentGreen}` : `2px solid ${color}`}
      _hover={typeof guessState === "undefined" ? { background: colors.statusGreenLight } : undefined}
      transition="color 0.1s ease-in-out, background 0.1s ease-in-out"
      aria-selected={guessState === "current"}
      aria-label={guessState === "correct" ? "riktig svar" : guessState === "incorrect" ? "feil svar" : undefined}
    >
      <Tag.Label>{tag.value}</Tag.Label>
    </Tag.Root>
  );
};
